"use client"
// 数字滚动：进入视口后触发 rAF 递增动画（IntersectionObserver + ease-out，无第三方依赖）
// 用于首页「数据背书」等统计数字，支持后缀（+、款、种）
import React, { useEffect, useRef, useState } from 'react'

export interface CountUpProps {
    value: number
    suffix?: string
    // 动画时长（秒），默认 1.2s
    duration?: number
    className?: string
}

export default function CountUp({ value, suffix = '', duration = 1.2, className }: CountUpProps) {
    const ref = useRef<HTMLSpanElement>(null)
    const started = useRef(false)
    const [display, setDisplay] = useState(0)

    useEffect(() => {
        const el = ref.current
        if (!el) return
        const observer = new IntersectionObserver(
            (entries) => {
                if (!entries[0].isIntersecting || started.current) return
                started.current = true
                observer.disconnect()
                const start = performance.now()
                const tick = (now: number) => {
                    const t = Math.min((now - start) / (duration * 1000), 1)
                    const eased = 1 - Math.pow(1 - t, 3) // ease-out cubic
                    setDisplay(Math.round(value * eased))
                    if (t < 1) requestAnimationFrame(tick)
                }
                requestAnimationFrame(tick)
            },
            { threshold: 0.4 }
        )
        observer.observe(el)
        return () => observer.disconnect()
    }, [value, duration])

    return (
        <span ref={ref} className={className}>
            {display.toLocaleString('en-US')}{suffix}
        </span>
    )
}
